import { useState } from "react";
import { REGIONS } from "./RegionList";
import "./RumiRegionsGrid.css";

export default function RumiRegionsGrid({
  title = "RUMI SALES REGIONS",
  subtitle = "CHỌN KHU VỰC ĐỂ XEM DANH SÁCH CỬA HÀNG",
  regions = REGIONS,
}) {
  const [open, setOpen] = useState(null); // { name, shops } | null

  return (
    <section className="rg-wrap">
      <div className="rg-inner">
        <h1 className="rg-title">{title}</h1>
        <p className="rg-sub">
          30 NHÀ PHÂN PHỐI - 20 KHU VỰC - 500 CỬA HÀNG TRÊN TOÀN QUỐC
        </p>
        <p className="rg-sub rg-sub-vi">{subtitle}</p>

        <div className="rg-grid">
          {regions.map((r, idx) => (
            <button
              key={r.name}
              className="rg-cell"
              onClick={() => setOpen(r)}
              aria-label={`Xem cửa hàng khu vực ${r.name}`}
            >
              <span className="rg-badge">{idx + 1}</span>
              <span className="rg-cell-title">{r.name}</span>
            </button>
          ))}
        </div>

        <div className="rg-footer-pill">Continue updating...</div>
      </div>

      {/* Modal */}
      {open && (
        <div
          className="rg-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="rg-modal-title"
        >
          <div className="rg-modal-card">
            <div className="rg-modal-header">
              <h3 id="rg-modal-title">Khu vực: {open.name}</h3>
              <button
                className="rg-close"
                onClick={() => setOpen(null)}
                aria-label="Đóng"
              >
                ✕
              </button>
            </div>
            <ul className="rg-shop-list">
              {open.shops.map((s, i) => (
                <li key={i} className="rg-shop">
                  <div className="rg-shop-name">{s.name}</div>
                  <div className="rg-shop-addr">{s.addr}</div>
                </li>
              ))}
            </ul>
          </div>
          <div className="rg-backdrop" onClick={() => setOpen(null)} />
        </div>
      )}
    </section>
  );
}
